mod.modules.define("Peers", "BaseModule", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.initPreviews(
			this.el.find("#peersList-12 a[data-auto-symbol]")
		);
	};

	fn.prototype.initPreviews = function($links) {
		for (var i = $links.length - 1; i >= 0; i--) {
			var $el = $links.eq(i);
			var symbol = $el.attr("data-auto-symbol");

			$el.symbolPreview({
				delay: {
					show : 500,
					hide : 250
				},
				symbol: symbol,
				onShow: $.proxy(this.tooltipOnShow, this),
				onHide: $.proxy(this.tooltipOnHide, this)
			});
		}
	};

	fn.prototype.events = {
		"table.peers-list a[data-symbol]": {
			"mouseenter": function (e, $el) {
				var symbol = $el.data("symbol");
				$el.parents("tr").addClass("highlight");
				this.el.find("a[rel=tooltip][data-symbol=" + symbol + "]").addClass("hover").trigger("mouseenter");
			},
			"mouseleave": function (e, $el) {
				var symbol = $el.data("symbol");
				$el.parents("tr").removeClass("highlight");
				this.el.find("a[rel=tooltip][data-symbol=" + symbol + "]").removeClass("hover").trigger("mouseleave");
			},
			"click": function(e, $el) {
				$el.symbolPreview("abort");
			}
		}
	};

});